import type { MemberModel } from '@/interfaces/model';
import type { JuntaDirectiva, Member, PositionType } from '@/interfaces/strapi';

const getPositionType = (cargo: string): PositionType => {
	const c = cargo.toLowerCase();
	if (c.includes('decano')) return 'Decano/a';
	if (c.includes('censor')) return 'Censor/a';
	if (c.includes('tesorero') || c.includes('secretario')) return 'Tesorero/a y Secretario/a';
	if (c.includes('archivero')) return 'Archivero/a';
	return 'Otros';
};

export const juntaDirectivaMapper = (data: MemberModel[]): JuntaDirectiva[] => {
	const map = data.reduce<Map<PositionType, Member[]>>((acc, item, idx) => {
		const positionType = getPositionType(item.cargo);
		const member: Member = {
			key: idx,
			name: item.nombre,
			position: item.cargo,
		};

		if (acc.has(positionType)) {
			acc.get(positionType)!.push(member);
		} else {
			acc.set(positionType, [member]);
		}
		return acc;
	}, new Map());

	return Array.from(map, ([positionType, members]) => ({
		positionType,
		members,
	}));
};
